import "./history.scss";

import { FunctionComponent, useEffect, useState } from "react";
import { ClipboardClock, BanknoteArrowDown, BanknoteArrowUp, ArrowDownLeftFromCircleIcon, ArrowDownLeftIcon, ArrowUpRightIcon } from 'lucide-react'
import { formatCurrencyBRL, formatCurrencyBRL4 } from "../../utils/format";
import { Deposit } from "../../models/Depoist";

let entries = 10;

const History: FunctionComponent<{list: Array<any>, showMore: boolean}> = ({list, showMore}) => {

    const[items, setList] = useState<any[]>([]);
    const[type,setType] = useState<string>('');

    const toggle = (t:string) => {
        setType(t);
        if (t === 'deposit') setList(list);
    }
    
    useEffect( () => {
        toggle('deposit');
    }, [list])

    const inOrOut = (value:string) :string => {
        if (value === 'PIX') return "Deposito";
        return "unknown";
    }

    const getEntryType = (item: Deposit) => {
        let c = false;
        if (item.type === 'PIX' && Number(item.value) > 0 ) c = true;
        return c;
    }

    const showMoreButton = () => {
        entries += 10;
    }

    return (
        <div className="history-wrapper">
            <h2 className="card card-history">

                <div className="text">
                    <ClipboardClock size={20} /> Historico
                    <small> ultimas {entries} entradas </small>
                </div>
                <div className="actions">
                    <div className={`btn ${type === 'deposit' ? 'purple' : ''} ghost`}>
                        <BanknoteArrowUp size={20} />depositos
                    </div>
                    <div className={`btn ${type === 'withdrawls' ? 'purple' : ''} ghost`}>
                        <BanknoteArrowDown size={20} />saques
                    </div>
                </div>
            </h2>

            <ul>

                { list && list.length > 0 && list.slice(0,entries).map( (item:any, index:number) => (
                    <li className={`history-item ${getEntryType(item) ? 'positivo' : 'negativo'}`} key={index}>
                        <div className="start-info">
                            { showMore && getEntryType(item) && (
                                <div className="round">
                                    <ArrowDownLeftIcon size={30} />
                                </div>
                            )}
                            { showMore && !getEntryType(item) && (
                                <div className="round">
                                    <ArrowUpRightIcon size={30} />
                                </div>
                            )}
                            <div className="wallet-item-info">
                                <div className="type">
                                    {getEntryType(item) ? <BanknoteArrowDown size={15}/> : <BanknoteArrowUp size={15} /> }
                                    {getEntryType(item) ? "entrada" : "saida" }
                                </div>
                                <p>
                                    {formatCurrencyBRL4(Number(item.value))}
                                    <b>{item.updatedAt}</b>
                                </p>
                            </div>
                        </div>
                        <div className="info-type">
                            {inOrOut(item.type)}
                        </div>
                        
                    </li>
                ))}

                { list && list.length === 0 && 
                    <p className="no-entries">Sem nenhuma transacao</p>
                }

            </ul>

            { showMore && list.length > 0 &&
                <div className="buttons">
                    <button className="btn purple">Carregar Mais</button> 
                </div>
            }

        </div>
        
    )
}

export default History;
